import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeavyEquipmentMortarTruck1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "heavy-equipment-mortar-truck-1" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 5.25,
			cy: 18.75,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 18.75,
			cy: 18.75,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.372,
			y1: 19.5,
			x2: 16.629,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.128,19.5H2.25A1.5,1.5,0,0,1,.75,18V15a1.5,1.5,0,0,1,.6-1.2l2.025-1.519a1.5,1.5,0,0,0,.523-.726l1.01-3.029A1.5,1.5,0,0,1,6.331,7.5H8.25A1.5,1.5,0,0,1,9.75,9v7.5h-9"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 16.5,
			x2: 23.25,
			y2: 16.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.119,
			y1: 4.336,
			x2: 21.914,
			y2: 11.131
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.109,6.481a1.307,1.307,0,0,0-.381-.993L20.762,3.522a1.3,1.3,0,0,0-.993-.381c-3.468.188-6.452,1.572-8.051,4.608a4.435,4.435,0,0,0,.9,5.154l.732.732a4.435,4.435,0,0,0,5.154.9C21.537,12.933,22.921,9.949,23.109,6.481Z"
		})
	]
});
export default SvgHeavyEquipmentMortarTruck1;
